﻿function showExitDialog(event) {
    // Correct method for causing the dialog to show in browsers.
    event.preventDefault();

    // Legacy methods for causing the dialog to show in older browsers.
    event.returnValue = "There are unsaved changes, are you sure you want to leave?";
    return true;
}

export class DocumentUtilities {
    blockUnsavedChanges(showUnsavedChangesDialogue: boolean) {
        if (showUnsavedChangesDialogue) {
            // Developer note: This won't add the event listener multiple times, it will only add it once.
            window.addEventListener("beforeunload", showExitDialog)
        } else {
            window.removeEventListener("beforeunload", showExitDialog)
        }
    }
}
